<div style="width: 100%;background-color: #FAFAFA;">
    <div fxLayout="column" fxLayoutGap="20px" style="margin:1% 2%; width: 100%;background-color: #FAFAFA;" fxFlex>
        
        <div fxLayout="row" fxFlex="100" fxLayoutGap="20px">
            <div fxLayout="column" fxFlex="25"  fxLayoutGap="10px" class="template-list-card">
                <div fxLayout="row" class="form-group" fxLayoutAlign="center center">
                    <div class="input-icons" fxLayoutAlign="start center" style="margin-top: 5%;">
                        <mat-icon class="search-icon" style="position:absolute"><span class="material-symbols-outlined">
                                search
                            </span></mat-icon>
                        <input type="search" class="form-control" [(ngModel)]="searchValue" placeholder="Search" (ngModelChange)="searchTemplates($event)">
                    </div>
                </div>
                <div fxLayout="row" fxLayoutGap="7px" fxLayoutAlign="center center">
                    <div>
                        <button  type="button" class="pending-btn" (click)="sortRequests('Pending')" >
                            <!-- (click)="sortRequests('Pending')" -->
                            <div class="pending-request" fxLayoutGap="10px"
                                [ngClass]="{'cardActive':activeCard == 1}">
                                <label fxLayoutAlign="center center" class="pending-label"> Pending
                                    </label>
                            </div>
                        </button>
                    </div>
                    <div>
                        <button type="button" class="pending-btn" (click)="sortRequests('Active')">
                            <div class="pending-request" fxLayoutGap="10px"
                                [ngClass]="{'cardActive':activeCard == 2}">
                                
                                <label fxLayoutAlign="center center" class="pending-label">Approved</label>
                            </div>
                        </button>
                    </div>
                
                
                </div>
                <span class="example-spacer"></span>
                <div>
                    <mat-list role="list" class="template-list">
                        <mat-list-item role="listitem" *ngFor="let template of reviewPendingTemplates;let i=index;"
                            [class.active]="i === selectedTemplateIndex" (click)="selectTemplate(template,i)">
                            <span fxFlex>{{template?.name}}</span>
                        </mat-list-item>
                    </mat-list>
                </div>
            </div>
            <div fxLayout="column" fxFlex="85" fxLayoutGap="20px">
                <div fxLayout="row" fxLayoutGap="20px">
                    <div fxLayout="column" fxFlex="30" class="verification-card" fxLayoutGap="30px">
                        <div fxLayout="column">
                            <label class="title-label">
                                Verification Status
                            </label>
                            <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center"
                                *ngIf="selectedTemplatedetails?.status == 'PENDING_REVIEW'">
                                <img src="assets/pendingRequest2-icon.svg">
                                <label class="pending-status">Pending</label>

                            </div>
                            <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center"
                                *ngIf="selectedTemplatedetails?.status == 'ACTIVE'">
                                     <img src="assets/approved-icon.svg">
                                    <label class="approved-status">Approved</label>
                            

                            </div>
                            <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center"
                                *ngIf="selectedTemplatedetails?.status == 'REJECTED'">
                                <img src="assets/rejected-icon.svg">
                                    <label class="rejected-status">Rejected</label>
                            </div>
                        </div>
                        <div fxLayout="column">
                            <label class="title-label">
                                Template Name
                            </label>
                            <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center" class="template-label">
                                <span>{{selectedTemplatedetails?.name}}</span>
                            </div>
                        </div>
                        <div fxLayout="column">
                            <label class="title-label">
                                Template Type
                            </label>
                            <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center" class="template-label">
                                <span>{{selectedTemplatedetails?.template.type}}</span>
                            </div>
                        </div>
                    </div>
                    <div fxLayout="column" class="verification-card" fxFlex="70">
                        <label class="title-label">
                            Message text
                        </label>
                        <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center" class="template-label">
                            <span>{{getMessageText()}}</span>
                            <!-- <span>{{selectedTemplatedetails?.template.text.body}}</span> -->
                        </div>

                    </div>

                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center" class="verification-card">
                    <label class="container checkbox-label"> I have verified the template’s name, picture and
                        description
                        <input type="checkbox" [checked]="checked" (click)="changeAgreeButton()">
                        <span class="checkmark"></span>
                    </label>


                    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px" fxlayoutGap="end center">
                        <button type="button" class="approve-btn" fxFlex="30" fxLayoutAlign="center center"
                            (click)="verifyTemplate('ACTIVE')" [disabled]="!checked">Approve</button>
                        <button type="button" class="reject-btn" fxFlex="30" fxLayoutAlign="center center"
                            [disabled]="!checked" (click)="openRejectpopup()">Reject</button>
                    </div>
                </div>



            </div>
        </div>
    </div>
</div>